import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

interface SpeciesEntry {
  species: string;
  count: number;
}

/// 인기 어종 TOP 10 수평 바 차트.
const TopSpeciesChart: React.FC<{ data: SpeciesEntry[] }> = ({ data }) => {
  // 내림차순 정렬 유지, Recharts 수평 바는 데이터 순서대로 위→아래로 표시되므로
  // 큰 값이 위에 오도록 원본 그대로 사용.
  const chartHeight = Math.max(240, data.length * 32);

  return (
    <Card sx={{ flex: '1 1 100%' }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          🎣 인기 어종 TOP 10
        </Typography>
        {data.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
            아직 어종 데이터가 없습니다.
          </Typography>
        ) : (
          <Box sx={{ width: '100%', height: chartHeight }}>
            <ResponsiveContainer>
              <BarChart
                data={data}
                layout="vertical"
                margin={{ top: 8, right: 40, bottom: 8, left: 60 }}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="#eee" horizontal={false} />
                <XAxis type="number" fontSize={12} allowDecimals={false} />
                <YAxis type="category" dataKey="species" fontSize={13} width={80} />
                <Tooltip />
                <Bar dataKey="count" fill="#0288d1" radius={[0, 4, 4, 0]}>
                  <LabelList dataKey="count" position="right" fontSize={12} />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default TopSpeciesChart;
